import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export type Banner = {
	id: string;
	name: string;
	actived: boolean;
	title: string;
	sub_title: string;
	button_text: string;
	button_url: string;
	button_color: string;
	image: string;
};

interface SuccessResponse {
	status: "success";
	data: Banner[];
}

interface ErrorResponse {
	status: "error";
	errors: { [key: string]: string };
}

type GetAdminResponse = SuccessResponse | ErrorResponse;

export async function fetchAdminBanners(): Promise<GetAdminResponse> {
	try {
		const { data } = await api.get("/banner");

		return {
			status: "success",
			data: data?.data || [],
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response?.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
